import { useResizeListenerPresenter } from './ResizeListener.presenter';

export const ResizeListener = (): null => {
  useResizeListenerPresenter();

  return null;
};
